import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { display } from "@mui/system";
//import "./styles.css";
import "antd/dist/antd.css";
import { Excel } from "antd-table-saveas-excel";
import "../../Pages/styles.css";
import Highlighter from "react-highlight-words";
import { Button, Input, Space, Table, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { withRouter, useHistory, useLocation } from "react-router-dom";

const { Text } = Typography;

// const columnGroupingModel = [
//   {
//     groupId: "naming",
//     headerName: "CTV",
//     headerClassName: "my-super-theme--naming-group",
//     children: [{ field: "revenue" }, { field: "precent" }],
//   },
//   {
//     groupId: "naming1",
//     headerName: "InApp",
//     headerClassName: "my-super-theme--naming-group1",
//     children: [{ field: "revenue1" }, { field: "precent1" }],
//   },
// ];

export default function DemandTable1({ newArray2 }) {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columns = [
    //  { field: "id", headerName: "ID", width: 90 },
    {
      title: "Bundle",
      dataIndex: "Bundle",
      flex: 1,
      width: 150,
      minWidth: 100,

      editable: true,
      ...getColumnSearchProps("Bundle"),
      sorter: (a, b) => a.Bundle.length - b.Bundle.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Name",
      dataIndex: "Name",
      flex: 1,
      minWidth: 100,
      editable: true,
      ...getColumnSearchProps("Name"),
      sorter: (a, b) => a.Name.length - b.Name.length,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "REQ",
      dataIndex: "REQ",
      flex: 1,

      minWidth: 100,
      editable: true,
      ...getColumnSearchProps("REQ"),
      sorter: (a, b) => a.REQ - b.REQ,
      render: (value) => {
        return value.toLocaleString("en");
      },
    },

    {
      title: "IMP",
      dataIndex: "IMP",
      flex: 1,
      minWidth: 100,
      editable: true,
      ...getColumnSearchProps("IMP"),
      sorter: (a, b) => a.IMP - b.IMP,
      render: (value) => {
        return value.toLocaleString("en");
      },
    },
    {
      title: "Fill",
      dataIndex: "Fill",
      flex: 1,
      minWidth: 100,
      editable: true,
      ...getColumnSearchProps("Fill"),
      sorter: (a, b) => a.Fill - b.Fill,
      render: (value) => {
        return value.toLocaleString("en");
      },
    },
    {
      title: "Rev",
      dataIndex: "Rev",
      flex: 1,
      minWidth: 100,
      editable: true,

      ...getColumnSearchProps("Rev"),
      sorter: (a, b) => a.Rev - b.Rev,
      render: (value) => {
        return "$" + value.toLocaleString("en");
      },
    },
    {
      title: "QS",
      dataIndex: "QS",
      flex: 1,
      minWidth: 100,
      editable: true,
      ...getColumnSearchProps("QS"),
      sorter: (a, b) => a.QS - b.QS,
      render: (value) => {
        return value.toLocaleString("en");
      },
    },
  ];
  const [pageSize, setPageSize] = React.useState(15);
  const handleClick = () => {
    const excel = new Excel();
    excel
      .addSheet("test")
      .addColumns(columns)
      .addDataSource(newArray2, {
        str2Percent: true,
      })
      .saveAs("Excel.xlsx");
  };
  const sum = newArray2.reduce((acc, cur) => acc + cur.REQ, 0);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();

  return (
    <div>
      <br></br>
      <div style={{ backgroundColor: "white" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h6>Top Filling Apps</h6>
        </div>
        <div
          style={{
            backgroundColor: "white",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <div style={{ width: "100%" }}>
            <div style={{ width: "100%" }}>
              <Table
                dataSource={newArray2}
                columns={columns}
                pagination={{
                  position: ["none", "none"],
                }}
                size="small"
                scroll={{ x: "max-content", y: 280 }}
              ></Table>
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
}
